export default __webpack_public_path__ + "static/media/MaksymB295.4e4202b7.jpg";